export const map = () => {
  const buttons = document.querySelectorAll('.map .tab-btn');
  const items = document.querySelectorAll('.map__map-item');


  buttons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      items.forEach(item => {
        item.classList.remove('active');
      });
      items[index].classList.add('active');

      buttons.forEach(item => {
        item.classList.remove('active');
      });
      button.classList.add('active');
    });
  });

  items.forEach((item) => {
    const texts = item.querySelectorAll('.map__text')
    const images = item.querySelectorAll('.map__images img')
    texts.forEach((text, index) => {
      text.addEventListener('click', (e) => {
        e.preventDefault();

        texts.forEach(item => {
          item.classList.remove('active');
        })
        text.classList.add('active');

        images.forEach(item => {
          item.classList.remove('active');
        })
        images[index].classList.add('active');
      })
    })
  })


  const scrollElements = (wrapper, slider, speed = 30, speedMobile = 70, hover = false, direction) => {
    const track = document.querySelector(wrapper);

    if (!track) {
      return;
    }

    const original = track.innerHTML;
    let tickerAnim = null;

    const waitImages = () => {
      const images = Array.from(track.querySelectorAll('img'));

      return Promise.all(images.map((image) => {
        if (image.complete) {
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          image.addEventListener('load', resolve, {once: true});
          image.addEventListener('error', resolve, {once: true});
        });
      }));
    }

    const createTruckAnim = () => {
      if(tickerAnim !== null){
        tickerAnim.kill();
        tickerAnim = null;
      }
      gsap.set(track, {x: 0});
      track.innerHTML = original + original + original;

      const singleSetWidth = track.scrollWidth / 3;

      if (!singleSetWidth) {
        return;
      }

      const currentSpeed = window.innerWidth <= 999 ? speedMobile : speed;

      tickerAnim = gsap.to(track, {
        x: `${direction}=${singleSetWidth}`,
        duration: singleSetWidth / currentSpeed,
        ease: "none",
        repeat: -1,
      });
    }

    if (hover) {
      const ticker = document.querySelector(slider);
      ticker.addEventListener('mouseenter', () => tickerAnim && tickerAnim.pause());
      ticker.addEventListener('mouseleave', () => tickerAnim && tickerAnim.resume());
    }

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => waitImages().then(createTruckAnim), 300);
    });

    waitImages().then(createTruckAnim);
  }

  scrollElements('.map__trusted-logos .map__trusted-logos-wrapper', '.map__trusted-logos', 30, 70, true, '-')

}
